module.exports = __webpack_public_path__ + "img/arrow_left_3.c7f59336.svg";